import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");

const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchDoctorOpdChargeRouters = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS,
) => {
  return axiosInstance.get(EndPoints.DOCTOR_OPD_CHARGE_ROUTER.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter,
    },
  });
};

export const createDoctorOpdChargeRouter = (payload) => {
  return axiosInstance.post(EndPoints.DOCTOR_OPD_CHARGE_ROUTER.CREATE, payload);
};

export const updateDoctorOpdChargeRouter = (payload) => {
  return axiosInstance.put(EndPoints.DOCTOR_OPD_CHARGE_ROUTER.UPDATE, payload);
};

export const deleteDoctorOpdChargeRouter = (id) => {
  const url = `${EndPoints.DOCTOR_OPD_CHARGE_ROUTER.DELETE}/${id}`;
  return axiosInstance.delete(url);
};

export const downloadOpdChargeCSV = () => {
  return axiosInstance.get(EndPoints.DOCTOR_OPD_CHARGE_ROUTER.DOWNLOAD_CSV, {
    responseType: "blob",
  });
};
